export const getDynamicLink = (lnKey: string) => {
    return `https://ln.evtn.me/${lnKey}`;
};
